import { DeleteAccountMessages, TranslationDeleteAccountMessages } from "@languages/interfaces";

export const messages: TranslationDeleteAccountMessages = {
  [DeleteAccountMessages.stepOne]: "Eliminar mi cuenta de cliente de Topcon",
  [DeleteAccountMessages.description]: `Eliminar una cuenta tiene los siguientes efectos:
    Su cuenta será eliminada y tendrá que crear una nueva cuenta si desea volver a iniciar sesión.`,
  [DeleteAccountMessages.stepTwo]: "Confirmar eliminación de cuenta",
  [DeleteAccountMessages.stepThree]: "Introduzca su contraseña de cliente de Topcon",
  [DeleteAccountMessages.deleteButton]: "Borrar cuenta",
  [DeleteAccountMessages.checkConfirmDeletion]: `Quiero eliminar todos los datos de mi
    cuenta, incluidos mi nombre de usuario, horarios, contratos, facturas, aprobaciones, informes y
    permisos, entre otros.`,
  [DeleteAccountMessages.deleteAccountFailed]: "Error al borrar la cuenta"
};